export enum EnergyStopSuppliersStatus {
    Incomplete,
    Complete,
}
